import PropTypes from 'prop-types';
import React from 'react';

import * as styles from './BreadCrumbNav.module.css';
import { PrimaryLink } from './Links';
import ShareIconList from './ShareIconList/ShareIconList';

/*
  Primarily used on the blog and learning center for social icons and breadcrumbs
 */
const BreadCrumbNav = ({ linkText, linkUrl, shareUrl, shareTitle, hideSocialIcons }) => {
  return (
    <nav className={styles.nav}>
      <PrimaryLink url={linkUrl} label={linkText} />
      {shareUrl && shareTitle && !hideSocialIcons && <ShareIconList url={shareUrl} title={shareTitle} />}
    </nav>
  );
};

BreadCrumbNav.propTypes = {
  linkText: PropTypes.string,
  linkUrl: PropTypes.string,
  shareIcons: PropTypes.bool,
  shareUrl: PropTypes.string,
  shareTitle: PropTypes.string,
};

export default BreadCrumbNav;
